export default __webpack_public_path__ + "efedee6175155b06f3c85fecb6385eac.png";